import { gql } from '@apollo/client';

export const appQuery = gql`
  query GetAppInfo($sessionContext: SessionContext!, $appId: String!) {
    app(sessionContext: $sessionContext, id: $appId) {
      id
      introSplash {
        displayTitle
        summary
        brandLogo {
          url
          altText
        }
        breakpointImages {
          altText
          breakpoint
          url
        }
      }
      productIntroVersion
      productIntroMaxSkips
      navigation {
        id
        displayTitle
        navigationLinks {
          tokenType
          logoType
          link {
            action {
              ... on URL {
                link
              }
              ... on Screen {
                id
              }
            }
            displayTitle
            ... on LinkText {
              description
            }
          }
        }
        corporateLinks {
          id
          action {
            ... on URL {
              link
            }
            ... on Screen {
              id
            }
          }
          displayTitle
          description
        }
      }
    }
  }
`;
